import { formatPhoneNumber } from '../../../utils/globalHelpers';

import { INTL_IDS } from './messages';

export const getDesktopProfileProps = ({
  email,
  isNameMilitaryLoading,
  isProfileLoading,
  legalName,
  militaryServiceStatus,
  mobileNumber,
  username,
}, isSslAuth, isSso, formatMessage) => ({
  heading: 'Profile',
  rowsData: [
    ...((isSslAuth || isSso) ? [] : [{
      details: username || '',
      label: formatMessage({ id: INTL_IDS.HOME_ROWSDATA_USERNAME_LABEL }),
      loading: isProfileLoading,
    }]),
    {
      buttonProps: {
        disabled: isSslAuth || isSso,
        label: formatMessage({ id: INTL_IDS.HOME_ROWSDATA_EMAIL_BUTTON_LABEL }),
        route: '/settings/profile/changeEmail',
      },
      details: email || '',
      label: formatMessage({ id: INTL_IDS.HOME_ROWSDATA_EMAIL_LABEL }),
      loading: isProfileLoading,
    },
    {
      buttonProps: {
        disabled: false,
        label: formatMessage({ id: INTL_IDS.HOME_ROWSDATA_MOBILE_BUTTON_LABEL }),
        route: '/settings/profile/changeMobileNumber',
      },
      details: formatPhoneNumber(mobileNumber) || '',
      label: formatMessage({ id: INTL_IDS.HOME_ROWSDATA_MOBILE_LABEL }),
      loading: isProfileLoading,
    },
    {
      buttonProps: {
        disabled: false,
        label: formatMessage({ id: INTL_IDS.HOME_ROWSDATA_LEGALNAME_BUTTON_LABEL }),
        route: '/settings/profile/editLegalName',
      },
      details: legalName,
      label: formatMessage({ id: INTL_IDS.HOME_ROWSDATA_LEGALNAME_LABEL }),
      loading: isNameMilitaryLoading,
    },
    {
      buttonProps: {
        disabled: false,
        label: formatMessage({ id: INTL_IDS.HOME_ROWSDATA_MILITARYSTATUS_BUTTON_LABEL }),
        route: '/settings/profile/editMilitaryStatus',
      },
      details: militaryServiceStatus,
      label: formatMessage({ id: INTL_IDS.HOME_ROWSDATA_MILITARYSTATUS_LABEL }),
      loading: isNameMilitaryLoading,
    },
  ],
  // eslint-disable-next-line
  text: 'This is the primary information associated with your online account. Make changes by clicking on the pencil icon next to each item.',
});

export const getMobileProfileProps = ({
  email,
  isNameMilitaryLoading,
  isProfileLoading,
  legalName,
  militaryServiceStatus,
  mobileNumber,
  username,
}, isSslAuth, isSso, formatMessage) => ({
  rowsData: [
    {
      details: email,
      isLoading: isProfileLoading,
      label: formatMessage({ id: INTL_IDS.HOME_ROWSDATA_EMAIL_LABEL }),
      pressProps: { isDisabled: isSslAuth || isSso, screen: 'EditEmail' },
    },
    {
      details: formatPhoneNumber(mobileNumber),
      isLoading: isProfileLoading,
      label: formatMessage({ id: INTL_IDS.HOME_ROWSDATA_MOBILE_LABEL }),
      pressProps: { isDisabled: false, screen: 'EditMobileNumber' },
    },
    {
      details: legalName,
      isLoading: isNameMilitaryLoading,
      label: formatMessage({ id: INTL_IDS.HOME_ROWSDATA_LEGALNAME_LABEL }),
      pressProps: { isDisabled: false, screen: 'EditLegalName' },
    },
    {
      details: militaryServiceStatus,
      isLoading: isNameMilitaryLoading,
      label: formatMessage({ id: INTL_IDS.HOME_ROWSDATA_MILITARYSTATUS_LABEL }),
      pressProps: { isDisabled: false, screen: 'EditMilitaryStatus' },
    },
  ],
  username,
  usernameLoading: isProfileLoading,
});
